// extracted by mini-css-extract-plugin
export default {"trips-list":"styles_trips-list__9Yb84"};